import {
  validationSchemas,
  commonValidationRules,
  validateField,
  validateForm,
} from './validation.schemas';

// Export all validation schemas for easy import
export { validationSchemas, commonValidationRules, validateField, validateForm };

// Common form initial values
export const initialValues = {
  login: {
    email: '',
    password: '',
    rememberMe: false,
  },

  register: {
    businessName: '',
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    password: '',
    confirmPassword: '',
    agreeUserAgreement: false,
    agreePrivacyPolicy: false,
    agreeElectronicDisclosures: false,
  },

  inviteRegister: {
    password: '',
    confirmPassword: '',
    inviteCode: '',
    agreeUserAgreement: false,
    agreePrivacyPolicy: false,
    agreeElectronicDisclosures: false,
  },

  forgotPassword: {
    email: '',
  },

  resetPassword: {
    password: '',
    confirmPassword: '',
  },

  changePassword: {
    oldPassword: '',
    newPassword: '',
    newPasswordConfirmation: '',
  },

  userProfile: {
    name: '',
    email: '',
    phone: '',
    address: '',
    bio: '',
  },

  settings: {
    siteName: '',
    siteUrl: '',
    adminEmail: '',
    supportEmail: '',
  },

  product: {
    name: '',
    description: '',
    price: 0,
    category: '',
    stock: 0,
  },

  contact: {
    name: '',
    email: '',
    subject: '',
    message: '',
  },
};

// Helper function to get schema by name
export const getValidationSchema = (schemaName: keyof typeof validationSchemas) => {
  return validationSchemas[schemaName];
};

// Helper function to get initial values by name
export const getInitialValues = (formName: keyof typeof initialValues) => {
  return initialValues[formName];
};

// Common validation patterns
export const patterns = {
  email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  phone: /^[0-9+\-\s()]+$/,
  username: /^[a-zA-Z0-9_]+$/,
  url: /^https?:\/\/.+/,
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$!%*?&]{6,}$/, // At least 6 chars, 1 lowercase, 1 uppercase, 1 number
};

// Validation messages
export const messages = {
  required: (field: string) => `Vui lòng nhập ${field}`,
  email: 'Email không hợp lệ',
  minLength: (min: number) => `Phải có ít nhất ${min} ký tự`,
  maxLength: (max: number) => `Không được quá ${max} ký tự`,
  password: 'Mật khẩu phải có ít nhất 6 ký tự',
  confirmPassword: 'Mật khẩu xác nhận không khớp',
  phone: 'Số điện thoại không hợp lệ',
  url: 'URL không hợp lệ',
  number: 'Phải là số',
  positiveNumber: 'Phải là số dương',
  date: 'Ngày không hợp lệ',
};
